/**
 * @fileoverview GET handler for the "/engagement/link_templates/tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementLinkTemplatesTags } from "./constants";
import type { EngagementLinkTemplatesTagsResult } from "./types";

export const getEngagementLinkTemplatesTags = reactQueryFetcherAdapter(
  engagementLinkTemplatesTags,
  (signal: AbortSignal): Promise<EngagementLinkTemplatesTagsResult> => {
    return fetch("/engagement/link_templates/tags", "GET", {}, { signal });
  }
);
